import React from 'react'
import Information from '../Pages/Information'
import Footer from './Footer'
import Navbar from './Navbar'

const Feature = () => {
  return (
    <>

        <Navbar/>
        <Information/>
        <Footer/>
    
    </>
  )
}

export default Feature